import Controller from '../abstracts/Controller';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'SmallInfoPushComponent',
      'EditorialPushComponent',
      'FullscreenCoverComponent',
      'QuoteAnimationComponent',
      'PerfectFitComponent',
      'NewSizesComponent',
      'ShopTheLookComponent',
      'ShopTheLookModule',
      'CountdownComponent',
      'VideoBrightcove',
      'StoreEventComponent',
      'ShoppableComponent',
      'LookBookComponent'
    ];
  }
}
